<template>
  <v-card class="elevation-12 contact-us-form p-0 free-trail-card" fill-height>
    <v-card-text>
      <v-form ref="form" @submit.prevent="submitForm">
        <v-row>
          <v-col cols="12" md="6" class="py-1">
            <p>First Name:</p>
            <v-text-field
              v-model="first_name"
              :rules="[rules.required, rules.name]"
              type="text"
              placeholder="John"
              solo
              :error-messages="errorMessages.first_name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Last Name:</p>
            <v-text-field
              v-model="last_name"
              :rules="[rules.required, rules.name]"
              type="text"
              placeholder="Smith"
              solo
              :error-messages="errorMessages.last_name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Company Name:</p>
            <v-text-field
              v-model="company_name"
              :rules="[rules.required]"
              placeholder="Smith Inc"
              solo
              :error-messages="errorMessages.company_name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Email Address:</p>
            <v-text-field
              v-model="email"
              :rules="[rules.required, rules.email]"
              placeholder="johnsmith@email.com"
              solo
              type="email"
              :error-messages="errorMessages.email"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Password:</p>
            <v-text-field
              v-model="password"
              :rules="[rules.required, rules.password]"
              placeholder="*******"
              solo
              type="password"
              :error-messages="errorMessages.password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="py-1">
            <p>Confirm Password:</p>
            <v-text-field
              v-model="confirm_password"
              :rules="[rules.required]"
              placeholder="*******"
              solo
              type="password"
              :error-messages="errorMessages.password"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <div id="newsletter">
              <v-checkbox
                style="box-shadow: none !important;"
                v-model="newsletter"
                :label="
                  `I would like to receive the latest news and updates from IMPROVE`
                "
              ></v-checkbox>
            </div>
            <div class="text-center form-terms">
              By signing up to this free trial you are agreeing to our
              <a :href="this.frontEndUrl +'/eula'">Terms and Conditions.</a> For details of how we
              use personal data please see our
              <a :href="this.frontEndUrl +'/privacy-policy'">Privacy Policy</a>.
            </div>
            <div class="text-center pt-5">
              <v-btn
                :loading="loading"
                class="cyber-security-form-btn"
                type="submit"
              >
                Start your FREE trial
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import AuthAPI from '@/api/auth.js';
import { IMPROVE_CONFIG } from '@/config.js';

export default {
  name: 'RegisterForm',
  data() {
    return {
      frontEndUrl: IMPROVE_CONFIG.FRONTEND_URL,
      errorMessages: {},
      first_name: '',
      last_name: '',
      company_name: '',
      email: '',
      password: '',
      confirm_password: '',
      newsletter: false,
      refID: '',
      successMessage:
        'We have notified our team with your request. Someone from our team will be in touch shortly.',
      loading: false,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return pattern.test(value) || 'Invalid email.';
        },
        name: (value) =>
          (value && value.length >= 2) || 'Name must be at least 2 characters.',
        password: function(value) {
          // Regular function declaration
          return (
            (value && value.length >= 6) ||
            'Password must be at least 6 characters.'
          );
        },
      },
    };
  },

  metaInfo() {
    return {
      title: 'Contact IMPROVE: #1 Online Learning Solution for SMEs',
      meta: [
        {
          name: 'description',
          content:
            "To start your FREE 14-day trial or to learn more about IMPROVE, the UK's first online learning platform for SMEs, get in touch with one of our experts today.",
        },
        {
          property: 'og:title',
          content: 'Contact IMPROVE: #1 Online Learning Solution for SMEs',
        },
        {
          property: 'og:description',
          content:
            "To start your FREE 14-day trial or to learn more about IMPROVE, the UK's first online learning platform for SMEs, get in touch with one of our experts today.",
        },
        {
          property: 'og:image',
          content:
            'https://www.improve.online/static/pages/contact/contact-bottom.png',
        },
      ],
    };
  },
  components: {
  },
  // created(), NOT beforeRouteEnter: this form is embedded in the Signup page,
  // it is never a route component, so a route guard here never runs. The
  // original afi= capture lived in beforeRouteEnter and was dead code for
  // exactly that reason.
  created() {
      // Two markers can arrive on the signup URL. `afi=<id>` is an affiliate
      // or partner referral id and becomes companies.referral_id. `ref=website`
      // is the marketing site's own trial button and becomes
      // companies.is_referred. The old code split the whole URL on "afi=" and
      // stored whatever followed, so a website signup (which has no afi=)
      // stored the string "undefined" and sent no `refer` at all: not one of
      // the 13 production trials created in 2026 is marked as coming from
      // the website. Read the query string properly and keep only real values.
      const q = new URLSearchParams((window.location.hash.split("?")[1] || window.location.search.replace(/^\?/, "")) || "");
      const afi = (q.get("afi") || "").trim();
      const ref = (q.get("ref") || "").trim();
      if (afi && afi !== "undefined") localStorage.setItem("refID", afi);
      if (ref) localStorage.setItem("signupRef", ref);
  },
  methods: {
    submitForm() {
      // check if password and confirm password are the same
      if (this.password !== this.confirm_password) {
        this.$snotify.error('Password and Confirm Password do not match');
        return;
      }

      if (this.$refs.form.validate()) {
        this.register();
      }
    },
    register() {
      this.loading = true;
      const storedRef = localStorage.getItem('refID');
      this.refID = storedRef && storedRef !== 'undefined' ? storedRef : '';
      const refer = localStorage.getItem('signupRef') || '';
      AuthAPI.register({
        // The marketing site's trial button: RegisterUserAction sets
        // is_referred = 1 when this is "website".
        refer: refer,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        company_name: this.company_name,
        password: this.password,
        confirm_password: this.confirm_password,
        newsletter: this.newsletter,
        banding: 1,
        refid: this.refID,
      })
        .then(() => {
          // No auto-login (Muhammad, 18 Sep 2026: "it should not be auto
          // login"; Sensolearn's form had logged the new admin straight in
          // since 2024). The account exists; the person is told so and signs
          // in with the email and password they just chose. The login page
          // then routes a trial admin to /welcome.
          this.loading = false;
          this.$router.push({ path: "/thankyou", query: { email: this.email } });
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.errorMessages = this.$gf.errorResponse(err);
        });
    },
  },
};
</script>
